module.exports = __webpack_public_path__ + "static/media/404.258b3eb0.png";